import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { forgotPasswordService } from './model/service'
import ESendOtp from "../e_send-otp/view/_send-otp"
import EForgotPasswordForm from './view/_forgot-password';
import { routePaths } from "../../../config/route-paths";

function EForgot_Password(props) {
  let path = props?.location?.state?.path;
  let sessionId = props?.location?.state?.sessionId;
  let userName = props?.location?.state?.userName;
  const [custNo, setcustNo] = useState()
  const forgotPasswordAPI=(username,action,tenantCode,sessionId,newPassword)=>{
      return forgotPasswordService.forgotPassword(username,action,tenantCode,sessionId,newPassword)
  }
  if(path === routePaths.LOGIN_VERIFY_OTP) {
    return(<EForgotPasswordForm custNo={custNo}  forgotPassword={forgotPasswordAPI} userName={userName} sessionId={sessionId}/>)
  } else {
    return(<ESendOtp setcustNo={setcustNo} forgotPassword={forgotPasswordAPI} path={routePaths.FORGOT_PASSWORD}/>)
  }
}

export default EForgot_Password